module.exports = __webpack_public_path__ + "img/radiologie.76741fd0.png";